export const STATUS_AUTENTICIDADE = {
  DENTRO_PRAZO: 1,
  FORA_PRAZO: 2,
};
